<template>
    <div class="card ribbon-box right bg-light card-height-100 profile-project-card shadow-none profile-project-primary">
        <div v-if="item.is_highest" class="ribbon-two ribbon-two-primary"><span>Highest</span></div>
        <div class="card-body">
            <div class="row g-2">
                <div v-if="item.qualification" class="col-12"> 
                    <span class="text-muted">Qualification</span>
                    <h6> {{item.qualification.title}} <span v-if="item.qualification.description">- {{ item.qualification.description }}</span></h6>
                </div>
                <div class="col-12"> 
                    <span class="text-muted">Institution <span v-if="item.institution_type">({{ item.institution_type.title }})</span></span>
                    <h6 v-if="item.institution"> {{item.institution.title}} </h6>
                    <h6 v-else> {{item.institution_name }} </h6>
                </div> 
                <div v-if="item.course || item.course_name" class="col-12"> 
                    <span class="text-muted">Course of Study</span>
                    <h6 v-if="item.course"> {{item.course.title}} </h6>
                    <h6 v-else> {{item.course_name}} </h6>
                </div>
                <div class="col-sm-6"> 
                    <span class="text-muted">Duration</span>
                    <h6> {{ $filters.number_format(item.duration)}} yrs </h6>
                </div>
                <div class="col-12">
                    <div class="row g-2">
                        <div class="col-sm-6"> 
                            <span class="text-muted">Start Date</span>
                            <h6> {{ $filters.date(item.start_date)}} </h6>
                        </div>
                        <div class="col-sm-6"> 
                            <span class="text-muted">End Date</span>
                            <h6> {{ $filters.date(item.end_date)}} </h6>
                        </div>
                    </div>
                </div>
                <div class="col-12"> 
                    <span class="text-muted">Remark</span>
                    <h6> {{ item.remark }} </h6>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row justify-content-between">
                <div class="col-auto">
                    <button @click.prevent="showProfileImg(item.certificate_path)" class="btn btn-sm btn-soft-primary">View Certificate</button>
                </div>
                <div class="col-auto">
                    <slot name="actions"></slot>
                </div>
            </div>
        </div>
    </div>
    
    </template>
    
    <script>
    export default {
        props:{
            item:{
                type:Object,
                required: true
            }
        }, 
    }
    </script>
    
    <style>
    
    </style>